/** @flow */

import React from "react";
import Loadable from "react-loadable";
import { Loader } from "@components";

const Loading = () => <Loader />;
const defaultConfig = {
  loading: Loading,
  delay: 300,
};
const loadAsync = (fn: Function) => Loadable(Object.assign({}, defaultConfig, { loader: fn }));

const availablePages = {
  Registration: () =>
    import(/* webpackChunkName: "UnauthPages" */ "@modules/account/pages/registration"),
  SetPassword: () =>
    import(/* webpackChunkName: "UnauthPages" */ "@modules/account/pages/set-password"),
  Error404: () => import(/* webpackChunkName: "UnauthPages" */ "@modules/client/pages/error-404"),
  ServiceUnavailable: () =>
    import(/* webpackChunkName: "UnauthPages" */ "@modules/account/pages/service-unavailable"),
  NoAccessPage: () =>
    import(/* webpackChunkName: "UnauthPages" */ "@modules/account/pages/no-access"),

  // Recording
  IncomingCallPage: () =>
    import(/* webpackChunkName: "RecordingModule" */ "@modules/recording/pages/incoming-call"),
  OutboundCallsPage: () =>
    import(/* webpackChunkName: "RecordingModule" */ "@modules/recording/pages/outbound-calls"),
  // Management
  ManagementPage: () =>
    import(/* webpackChunkName: "ManagementModule" */ "@modules/management/pages/management"),
  ContactCentreDashboardPage: () =>
    import(
      /* webpackChunkName: "ManagementModule" */ "@modules/management/pages/contact-centre-dashboard"
    ),
  QueueManagementPage: () =>
    import(/* webpackChunkName: "ManagementModule" */ "@modules/management/pages/queue-management"),
  ScriptManagementPage: () =>
    import(
      /* webpackChunkName: "ManagementModule" */ "@modules/management/pages/script-management"
    ),
  ManagementMessagesPage: () =>
    import(/* webpackChunkName: "ManagementModule" */ "@modules/management/pages/messages"),
  IncidentRegisterPage: () =>
    import(
      /* webpackChunkName: "ManagementModule" */ "@modules/management/pages/incident-register"
    ),
  IncidentRatesReportPage: () =>
    import(
      /* webpackChunkName: "ManagementModule" */ "@modules/management/pages/incident-rates-report"
    ),
  ClassificationsPage: () =>
    import(/* webpackChunkName: "ManagementModule" */ "@modules/management/pages/classifications"),
  InterventionsPage: () =>
    import(/* webpackChunkName: "ManagementModule" */ "@modules/management/pages/interventions"),
  ServiceDeskManagementPage: () =>
    import(/* webpackChunkName: "ManagementModule" */ "@modules/management/pages/service-desk"),
  HealthNoticesPage: () =>
    import(/* webpackChunkName: "ManagementModule" */ "@modules/management/pages/health-notices"),
  ImageLibraryPage: () =>
    import(/* webpackChunkName: "ManagementModule" */ "@modules/management/pages/image-library"),

  /*eslint-enable*/
};

let pages: { [key: $Keys<typeof availablePages>]: any } = {};

for (const component of Object.keys(availablePages)) {
  // Register all pages
  pages[component] = loadAsync(availablePages[component]);
}

export default pages;
